<template>
  <base-section id="features-detailed">
    <v-container>
      <div style="padding-left: 12px; padding-right: 12px; margin-bottom: 24px">
        <v-row>
          <div style="width: 100%">
            <p>
              {{ $t("Visit the forum by clicking this button:") }}
              <a
                href="https://talk.hoarder.software"
                target="_blank"
                rel="noopener noreferrer"
                ><v-btn color="primary">{{ $t("VISIT THE FORUM") }}</v-btn></a
              >
            </p>
          </div>
        </v-row>
      </div>
    </v-container>
  </base-section>
</template>

<script>
export default {
  name: "SectionFeaturesDetailed",

  data: () => ({}),

  computed: {},

  methods: {},

  /**
   * Lifecycle Hooks
   */
  created() {}
};
</script>
